"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SecondsInput = void 0;

var antd_1 = require("antd");

var lodash_1 = require("lodash");

var react_1 = __importDefault(require("react"));

exports.SecondsInput = react_1["default"].forwardRef(function (_a, ref) {
  var value = _a.value,
      _onChange = _a.onChange,
      hideSuffix = _a.hideSuffix,
      props = __rest(_a, ["value", "onChange", "hideSuffix"]);

  return react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement(antd_1.InputNumber, Object.assign({
    value: !(0, lodash_1.isNil)(value) ? value / 60 : undefined,
    onChange: function onChange(val) {
      if (_onChange) {
        _onChange(!(0, lodash_1.isNil)(val) ? parseFloat(val.toString()) * 60 : '');
      }
    },
    min: 0,
    ref: ref,
    style: hideSuffix ? {
      width: '100%'
    } : undefined
  }, props)), hideSuffix ? null : react_1["default"].createElement("span", null, "\xA0minutes"));
});